import { SVGProps } from "react";

const PenIcon = (props: SVGProps<SVGSVGElement>) => {
  const { width = 25, height = 25, fill = "black" } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.8619 0.299792C14.2616 -0.0999307 14.9097 -0.0999307 15.3094 0.299792L17.7002 2.6906C18.0999 3.09032 18.0999 3.7384 17.7002 4.13812L3.83833 18H0V14.1617L13.8619 0.299792ZM1.22826 14.6704V16.7717H3.32956L15.0741 5.02721L12.9728 2.92591L1.22826 14.6704ZM13.8413 2.05739L15.9426 4.15869L16.6869 3.41436L14.5856 1.31306L13.8413 2.05739Z"
        fill={fill}
      />
    </svg>
  );
};

export default PenIcon;
